import { ApiFieldToModifyOption, DeletedOption } from '../types';

export const mapToFlowFieldToClear = (field: ApiFieldToModifyOption) => ({
  ...field,
  deleted: field.deleted,
  error: field.deleted,
  value: field.id,
  label: field.displayName,
});

export const mapToApiFieldToClear = ({ value }: DeletedOption) => value;
